"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlNoOpGraphicsComponent = void 0;
const dummy_gl_program_specification_1 = require("../../rendering/gl/shaders/dummy-gl-program-specification");
const no_transform_provider_1 = require("../../rendering/transform-components/no-transform-provider");
const e_graphics_component_type_1 = require("../../rendering/graphics-components/e-graphics-component-type");
/**
 * @public
 * A graphics component for webgl/webgl2 renderer that doesn't draw.
 */
class GlNoOpGraphicsComponent {
    constructor() {
        this.type = e_graphics_component_type_1.EGraphicsComponentType.Entity;
        this.specification = dummy_gl_program_specification_1.dummyGlProgramSpecification;
        this.transform = new no_transform_provider_1.NoTransformProvider();
    }
    getCacheId() {
        return "NoOpGraphicsComponent";
    }
    initialize() {
        // no action needed
    }
    onBeforeUpdate() {
        // no action needed
    }
    update() {
        // no action needed
    }
}
exports.GlNoOpGraphicsComponent = GlNoOpGraphicsComponent;
//# sourceMappingURL=gl-no-op-graphics-component.js.map